import React from "react";

/*
 * The coloured visit-type badge OSA's board shows next to each waiting / RT /
 * Pay-in-Cash patient (OSA build, MedTrack.jsx getPurposeBadge), for a board
 * profile with purposeBadges (7825). Label and colour from the visit purpose:
 * Walk-In pink, Labs / Inj / Labs/Inj amber, New grey, Follow Up purple, Rep
 * green; anything else keeps its own text (cut to 9 letters + "…" past 10) in
 * green.
 */
export function purposeBadgeStyle(purpose) {
  if (!purpose) return null;
  const p = String(purpose).toLowerCase();
  if (p.includes("walk")) return { label: "Walk-In", color: "#D946EF" };
  if (p.includes("lab") && p.includes("inj")) return { label: "Labs/Inj", color: "#D97706" };
  if (p.includes("lab")) return { label: "Labs", color: "#D97706" };
  if (p.includes("inj")) return { label: "Inj", color: "#D97706" };
  if (p.includes("new")) return { label: "New", color: "#6B7280" };
  if (p.includes("follow")) return { label: "Follow Up", color: "#7C3AED" };
  if (p.includes("rep")) return { label: "Rep", color: "#16A34A" };
  const text = String(purpose);
  return { label: text.length > 10 ? `${text.substring(0, 9)}…` : text, color: "#16A34A" };
}

export function PurposeBadge({ purpose }) {
  const style = purposeBadgeStyle(purpose);
  if (!style) return null;
  return (
    <span
      data-testid="purpose-badge"
      className="inline-flex items-center justify-center px-3 py-1 text-xs font-medium rounded-full whitespace-nowrap border"
      style={{ color: style.color, borderColor: style.color, backgroundColor: `${style.color}20` }}
    >
      {style.label}
    </span>
  );
}

export default PurposeBadge;
